import { render, staticRenderFns } from "./phone-input.vue?vue&type=template&id=6c51d9e2"
import script from "./phone-input.vue?vue&type=script&lang=js"
export * from "./phone-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c51d9e2')) {
      api.createRecord('6c51d9e2', component.options)
    } else {
      api.reload('6c51d9e2', component.options)
    }
    module.hot.accept("./phone-input.vue?vue&type=template&id=6c51d9e2", function () {
      api.rerender('6c51d9e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/inputs/phone-input.vue"
export default component.exports